export default __webpack_public_path__ + "static/first_view@2x-fd40ecbb920b0308a90be0c0508e1fa9.png";